var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.3202 1.91895C9.19967 1.91895 8.19682 2.46371 7.57158 3.29942C6.94634 2.46371 5.94348 1.91895 4.82301 1.91895C2.92253 1.91895 1.3811 3.46656 1.3811 5.37942C1.3811 6.11609 1.49872 6.79704 1.70301 7.42847C2.6811 10.5237 5.69587 12.3747 7.18777 12.8823C7.39825 12.9566 7.74491 12.9566 7.95539 12.8823C9.44729 12.3747 12.4621 10.5237 13.4402 7.42847C13.6444 6.79704 13.7621 6.11609 13.7621 5.37942C13.7621 3.46656 12.2206 1.91895 10.3202 1.91895Z",
    fill: "#00a14b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartBold);
export default __webpack_public_path__ + "static/media/heart-bold.113251d787c373894f77a2fc6375cb00.svg";
export { ForwardRef as ReactComponent };